export default class Insurance {
    static config = {
        DHPY: "DhipayaInsurance"
    }
    code = null
    constructor( code ) {
        this.code = Insurance.config[code]
    }

    getClass(){
        const insurance = require( `@/insurances/${this.code}` ).default
        return new insurance()
    }
}